package com.tedd.db

import app.cash.sqldelight.Query
import app.cash.sqldelight.TransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class FocusSessionQueries(
  driver: SqlDriver,
) : TransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    note: String?,
    skill_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(1_528_412_941, arrayOf("focus_session"), driver, "FocusSession.sq",
      "selectAll",
      "SELECT focus_session.id, focus_session.started_at, focus_session.ended_at, focus_session.focus_minutes, focus_session.break_minutes, focus_session.pomodoros, focus_session.task_id, focus_session.note, focus_session.skill_id, focus_session.created_at, focus_session.updated_at, focus_session.is_deleted, focus_session.deleted_at, focus_session.synced_at FROM focus_session WHERE is_deleted = 0 ORDER BY started_at DESC") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectAll(): Query<Focus_session> = selectAll { id, started_at, ended_at,
      focus_minutes, break_minutes, pomodoros, task_id, note, skill_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Focus_session(
      id,
      started_at,
      ended_at,
      focus_minutes,
      break_minutes,
      pomodoros,
      task_id,
      note,
      skill_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectBetween(
    started_at: Long,
    started_at_: Long,
    mapper: (
      id: String,
      started_at: Long,
      ended_at: Long,
      focus_minutes: Long,
      break_minutes: Long,
      pomodoros: Long,
      task_id: String?,
      note: String?,
      skill_id: String?,
      created_at: Long,
      updated_at: Long,
      is_deleted: Long,
      deleted_at: Long?,
      synced_at: Long?,
    ) -> T,
  ): Query<T> = SelectBetweenQuery(started_at, started_at_) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectBetween(started_at: Long, started_at_: Long): Query<Focus_session> =
      selectBetween(started_at, started_at_) { id, started_at__, ended_at, focus_minutes,
      break_minutes, pomodoros, task_id, note, skill_id, created_at, updated_at, is_deleted,
      deleted_at, synced_at ->
    Focus_session(
      id,
      started_at__,
      ended_at,
      focus_minutes,
      break_minutes,
      pomodoros,
      task_id,
      note,
      skill_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByTask(task_id: String?, mapper: (
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    note: String?,
    skill_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByTaskQuery(task_id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectByTask(task_id: String?): Query<Focus_session> = selectByTask(task_id) { id,
      started_at, ended_at, focus_minutes, break_minutes, pomodoros, task_id_, note, skill_id,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Focus_session(
      id,
      started_at,
      ended_at,
      focus_minutes,
      break_minutes,
      pomodoros,
      task_id_,
      note,
      skill_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectDirty(mapper: (
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    note: String?,
    skill_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = Query(-71_288_258, arrayOf("focus_session"), driver, "FocusSession.sq",
      "selectDirty",
      "SELECT focus_session.id, focus_session.started_at, focus_session.ended_at, focus_session.focus_minutes, focus_session.break_minutes, focus_session.pomodoros, focus_session.task_id, focus_session.note, focus_session.skill_id, focus_session.created_at, focus_session.updated_at, focus_session.is_deleted, focus_session.deleted_at, focus_session.synced_at FROM focus_session WHERE synced_at IS NULL OR synced_at < updated_at") {
      cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectDirty(): Query<Focus_session> = selectDirty { id, started_at, ended_at,
      focus_minutes, break_minutes, pomodoros, task_id, note, skill_id, created_at, updated_at,
      is_deleted, deleted_at, synced_at ->
    Focus_session(
      id,
      started_at,
      ended_at,
      focus_minutes,
      break_minutes,
      pomodoros,
      task_id,
      note,
      skill_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun <T : Any> selectByIdAnyState(id: String, mapper: (
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    note: String?,
    skill_id: String?,
    created_at: Long,
    updated_at: Long,
    is_deleted: Long,
    deleted_at: Long?,
    synced_at: Long?,
  ) -> T): Query<T> = SelectByIdAnyStateQuery(id) { cursor ->
    mapper(
      cursor.getString(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getLong(4)!!,
      cursor.getLong(5)!!,
      cursor.getString(6),
      cursor.getString(7),
      cursor.getString(8),
      cursor.getLong(9)!!,
      cursor.getLong(10)!!,
      cursor.getLong(11)!!,
      cursor.getLong(12),
      cursor.getLong(13)
    )
  }

  public fun selectByIdAnyState(id: String): Query<Focus_session> = selectByIdAnyState(id) { id_,
      started_at, ended_at, focus_minutes, break_minutes, pomodoros, task_id, note, skill_id,
      created_at, updated_at, is_deleted, deleted_at, synced_at ->
    Focus_session(
      id_,
      started_at,
      ended_at,
      focus_minutes,
      break_minutes,
      pomodoros,
      task_id,
      note,
      skill_id,
      created_at,
      updated_at,
      is_deleted,
      deleted_at,
      synced_at
    )
  }

  public fun insert(
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(-1_900_929_103, """
        |INSERT INTO focus_session(id, started_at, ended_at, focus_minutes, break_minutes, pomodoros, task_id, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 9) {
          bindString(0, id)
          bindLong(1, started_at)
          bindLong(2, ended_at)
          bindLong(3, focus_minutes)
          bindLong(4, break_minutes)
          bindLong(5, pomodoros)
          bindString(6, task_id)
          bindLong(7, created_at)
          bindLong(8, updated_at)
        }
    notifyQueries(-1_900_929_103) { emit ->
      emit("focus_session")
    }
  }

  public fun softDelete(
    deleted_at: Long?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_197_096_813,
        """UPDATE focus_session SET is_deleted = 1, deleted_at = ?, updated_at = ? WHERE id = ?""",
        3) {
          bindLong(0, deleted_at)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_197_096_813) { emit ->
      emit("focus_session")
    }
  }

  public fun markSynced(
    synced_at: Long?,
    id: String,
    updated_at: Long,
  ) {
    driver.execute(-1_894_976_865,
        """UPDATE focus_session SET synced_at = ? WHERE id = ? AND updated_at <= ?""", 3) {
          bindLong(0, synced_at)
          bindString(1, id)
          bindLong(2, updated_at)
        }
    notifyQueries(-1_894_976_865) { emit ->
      emit("focus_session")
    }
  }

  public fun update(
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    created_at: Long,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-1_555_982_911, """
        |UPDATE focus_session
        |SET started_at = ?, ended_at = ?, focus_minutes = ?, break_minutes = ?, pomodoros = ?, task_id = ?, created_at = ?, updated_at = ?
        |WHERE id = ?
        """.trimMargin(), 9) {
          bindLong(0, started_at)
          bindLong(1, ended_at)
          bindLong(2, focus_minutes)
          bindLong(3, break_minutes)
          bindLong(4, pomodoros)
          bindString(5, task_id)
          bindLong(6, created_at)
          bindLong(7, updated_at)
          bindString(8, id)
        }
    notifyQueries(-1_555_982_911) { emit ->
      emit("focus_session")
    }
  }

  public fun restore(updated_at: Long, id: String) {
    driver.execute(341_120_150,
        """UPDATE focus_session SET is_deleted = 0, deleted_at = NULL, updated_at = ? WHERE id = ?""",
        2) {
          bindLong(0, updated_at)
          bindString(1, id)
        }
    notifyQueries(341_120_150) { emit ->
      emit("focus_session")
    }
  }

  public fun insertWithNote(
    id: String,
    started_at: Long,
    ended_at: Long,
    focus_minutes: Long,
    break_minutes: Long,
    pomodoros: Long,
    task_id: String?,
    note: String?,
    skill_id: String?,
    created_at: Long,
    updated_at: Long,
  ) {
    driver.execute(1_429_816_489, """
        |INSERT INTO focus_session(id, started_at, ended_at, focus_minutes, break_minutes, pomodoros, task_id, note, skill_id, created_at, updated_at)
        |VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)
        """.trimMargin(), 11) {
          bindString(0, id)
          bindLong(1, started_at)
          bindLong(2, ended_at)
          bindLong(3, focus_minutes)
          bindLong(4, break_minutes)
          bindLong(5, pomodoros)
          bindString(6, task_id)
          bindString(7, note)
          bindString(8, skill_id)
          bindLong(9, created_at)
          bindLong(10, updated_at)
        }
    notifyQueries(1_429_816_489) { emit ->
      emit("focus_session")
    }
  }

  public fun updateSkill(
    skill_id: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(-846_285_552,
        """UPDATE focus_session SET skill_id = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, skill_id)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(-846_285_552) { emit ->
      emit("focus_session")
    }
  }

  public fun updateNote(
    note: String?,
    updated_at: Long,
    id: String,
  ) {
    driver.execute(1_496_576_339,
        """UPDATE focus_session SET note = ?, updated_at = ? WHERE id = ?""", 3) {
          bindString(0, note)
          bindLong(1, updated_at)
          bindString(2, id)
        }
    notifyQueries(1_496_576_339) { emit ->
      emit("focus_session")
    }
  }

  private inner class SelectBetweenQuery<out T : Any>(
    public val started_at: Long,
    public val started_at_: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("focus_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("focus_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(-1_676_142_732, """
    |SELECT focus_session.id, focus_session.started_at, focus_session.ended_at, focus_session.focus_minutes, focus_session.break_minutes, focus_session.pomodoros, focus_session.task_id, focus_session.note, focus_session.skill_id, focus_session.created_at, focus_session.updated_at, focus_session.is_deleted, focus_session.deleted_at, focus_session.synced_at FROM focus_session
    |WHERE is_deleted = 0 AND started_at >= ? AND started_at < ?
    |ORDER BY started_at DESC
    """.trimMargin(), mapper, 2) {
      bindLong(0, started_at)
      bindLong(1, started_at_)
    }

    override fun toString(): String = "FocusSession.sq:selectBetween"
  }

  private inner class SelectByTaskQuery<out T : Any>(
    public val task_id: String?,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("focus_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("focus_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(null, """
    |SELECT focus_session.id, focus_session.started_at, focus_session.ended_at, focus_session.focus_minutes, focus_session.break_minutes, focus_session.pomodoros, focus_session.task_id, focus_session.note, focus_session.skill_id, focus_session.created_at, focus_session.updated_at, focus_session.is_deleted, focus_session.deleted_at, focus_session.synced_at FROM focus_session
    |WHERE task_id ${ if (task_id == null) "IS" else "=" } ? AND is_deleted = 0
    |ORDER BY started_at DESC
    """.trimMargin(), mapper, 1) {
      bindString(0, task_id)
    }

    override fun toString(): String = "FocusSession.sq:selectByTask"
  }

  private inner class SelectByIdAnyStateQuery<out T : Any>(
    public val id: String,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("focus_session", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("focus_session", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(683_611_147,
        """SELECT focus_session.id, focus_session.started_at, focus_session.ended_at, focus_session.focus_minutes, focus_session.break_minutes, focus_session.pomodoros, focus_session.task_id, focus_session.note, focus_session.skill_id, focus_session.created_at, focus_session.updated_at, focus_session.is_deleted, focus_session.deleted_at, focus_session.synced_at FROM focus_session WHERE id = ?""",
        mapper, 1) {
      bindString(0, id)
    }

    override fun toString(): String = "FocusSession.sq:selectByIdAnyState"
  }
}
